const createCategoryTree = (input) => {

  let categoryTree = [];
  let categoryTreeTemp = [];

  input.forEach((item, index) => {
    if (typeof item.parent === "undefined") {
      categoryTree.push({_id: item._id, name: item.name, slug: item.slug, arrayIndex: index, empty: typeof item.empty === "undefined" ? true : item.empty});
    } else {
      categoryTreeTemp.push({_id: item._id, name: item.name, slug: item.slug, parent: item.parent, arrayIndex: index, empty: typeof item.empty === "undefined" ? true : item.empty});
    }

  });

  categoryTree.forEach((item, index) => {
    categoryTreeTemp.forEach((item2aa, index2) => {
      if (item._id === item2aa.parent) {
        if (typeof item.subcategory === "undefined") {
          item.subcategory = [];
        }
        item.empty = false;
        item.subcategory.push(item2aa);
      }
    });
  });


  return categoryTree;

}

const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

exports.createCategoryTree = createCategoryTree;
exports.shuffle = shuffle;



// WEBPACK FOOTER //
// ./src/lib/helpers.js